export default __webpack_public_path__ + "static/media/profile_information.34afa6da.svg";